<script setup>
import PostesSelectionnesGroup from '@/components/fiche-aim/fiche-aim/versements/tab-postes-a-verser.vue'
import SMessageChargement from '@/components/global/s-message-chargement.vue'
</script>

<template>
  <v-form>
    <v-container>
      <v-row no-gutters>
        <v-col>
          <postes-selectionnes-group />
        </v-col>
        <v-col cols="auto">
          <v-date-picker
            :picker-date="minDate"
            :min="minDate"
            :max="maxDate"
            :first-day-of-week="1"
            color="primary"
            locale="fr"
            v-model="dates"
            multiple
            no-title
            scrollable
          >
          </v-date-picker>
          <p class="text-center text-body-1 mb-5">Moyen de paiement</p>
          <s-message-chargement v-if="loading">Chargement des moyens de paiements</s-message-chargement>
          <v-row v-else justify="center">
            <v-btn-toggle v-model="moyenDePaiement" rounded borderless color="primary" mandatory>
              <v-btn v-for="m in moyensDePaiement" :key="m.moyenDePaiementId" :value="m.moyenDePaiementId">
                <v-icon left>{{ icone(m.moyenDePaiementId) }}</v-icon>
                <span class="hidden-sm-and-down">{{ m.libelle }}</span>
              </v-btn>
            </v-btn-toggle>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  props: {
    annee: {
      type: Number,
      required: true,
    },
    mois: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      dates: [],
      moyenDePaiement: 'ESPECE',
    }
  },
  computed: {
    ...mapGetters({
      moyensDePaiement: 'moyenDePaiement/getMoyenDePaiements',
      getIcone: 'moyenDePaiement/getIconePourMoyenDePaiementAimId',
      datesEnregistes: 'preparationVersement_IHM_helper/getDatesVersements',
    }),
    minDate() {
      return moment([this.annee, this.mois, 1]).subtract(1, 'months').format('YYYY-MM-DD')
    },
    maxDate() {
      return moment([this.annee, this.mois, 1]).subtract(1, 'days').format('YYYY-MM-DD')
    },
  },
  methods: {
    ...mapActions({
      fetchMoyenDePaiements: 'moyenDePaiement/fetchMoyenDePaiements',
      setDates: 'preparationVersement_IHM_helper/setDates',
      setMoyenDePaiement: 'preparationVersement_IHM_helper/setMoyenDePaiement',
    }),
    icone(moyenDePaiementId) {
      return this.getIcone(moyenDePaiementId)
    },
  },
  watch: {
    datesEnregistes: function (newDates) {
      this.dates = newDates
    },
    dates: function (newDates) {
      this.setDates(newDates)
    },
    moyenDePaiement: function (newMoyenDePaiement) {
      this.setMoyenDePaiement(newMoyenDePaiement)
    },
  },
  created() {
    this.fetchMoyenDePaiements().then((this.loading = false))
    this.setMoyenDePaiement(this.moyenDePaiement)
  },
}
</script>

<style scoped></style>
